import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Map as LeafletMap, TileLayer, Marker } from 'react-leaflet'
import L from 'leaflet'
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

// JS
import { MAP_URL } from '../../../../../utils/constants'

// CSS
import 'leaflet/dist/leaflet.css'
import './LocationMap.css'

export default class LocationMap extends PureComponent {

    static propTypes = {
        location: PropTypes.array.isRequired,
    }

    render() {

        let DefaultIcon = L.icon({
            iconUrl: icon,
            shadowUrl: iconShadow
        });

        return (
            <div className="map-container">
                <LeafletMap center={this.props.location} zoom={14} ref="leafletMap">
                    <TileLayer url={MAP_URL} />
                    <Marker position={this.props.location} icon={DefaultIcon} />
                </LeafletMap>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/main/exhibition/exhibitiondetails/locationmap/LocationMap.js